import { useEffect, useState } from 'react';
import { formatFileSize, getImportFileKind } from '../../../../../../helpers/menuImportHelper';

type _SelectedFileCardProps = {
    file: File;
    removeLabel: string;
    onRemove: () => void;
};

/** One picked file as a card: an image thumbnail (or a PDF / generic icon), the name, the size and a remove button. */
const SelectedFileCard = ({ file, removeLabel, onRemove }: Readonly<_SelectedFileCardProps>) => {
    const kind = getImportFileKind(file.name, file.type);
    const [thumbnail, setThumbnail] = useState<string | null>(null);

    // The object URL lives as long as the card: it is revoked when the file is removed and when the step unmounts.
    useEffect(() => {
        if (kind !== 'image') return undefined;
        const url = URL.createObjectURL(file);
        setThumbnail(url);
        return () => {
            URL.revokeObjectURL(url);
            setThumbnail(null);
        };
    }, [file, kind]);

    let preview = <i className="ri-file-line" />;
    if (kind === 'pdf') preview = <i className="ri-file-pdf-2-line" data-testid="file-preview-pdf" />;
    if (kind === 'image' && thumbnail) preview = <img src={thumbnail} alt="" data-testid="file-preview-image" />;

    return (
        <li data-testid="selected-file-card">
            <div className={`bulk-upload-file-preview ${kind === 'pdf' ? 'pdf' : ''}`}>{preview}</div>
            <span className="bulk-upload-file-name" title={file.name}>
                {file.name}
            </span>
            <span className="bulk-upload-file-size">{formatFileSize(file.size)}</span>
            <button type="button" className="bulk-upload-file-remove" aria-label={removeLabel} onClick={onRemove}>
                <i className="ri-close-line" />
            </button>
        </li>
    );
};

export default SelectedFileCard;
